module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-01"
  }, [_c('v-container', {
    staticClass: "adorn-bottom-left",
    attrs: {
      "pb-5": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', {
    staticClass: "davi-curs font-red big-font animated fadeInLeft"
  }, [_c('image-app', {
    attrs: {
      "imaSize": 80,
      "imaSrc": "design/banco3-1-1",
      "imaAlt": ""
    }
  }), _vm._v(" Si: ")], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Ingresos mayores que gastos',
      "videoEmbed": "ADMINISTRACIONDINERO44IngresosMayoresQueGastos.mp4"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "animated fadeIn dura_1",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('p', [_c('strong', [_vm._v(" El total de sus ingresos es mayor que el total de sus gastos")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "mayot-menor-que borde-dashed animated fadeIn dura_2",
    attrs: {
      "aria-label": "Los ingresos son mayores que los gastos"
    }
  }, [_c('v-layout', {
    attrs: {
      "aria-hidden": "true",
      "row": "",
      "wrap": "",
      "justify-center": "",
      "pt-3": "",
      "pl-4": "",
      "pr-4": ""
    }
  }, [_c('v-flex', {
    staticClass: "aligner animated fadeInLeft dura_2",
    attrs: {
      "sm4": ""
    }
  }, [_c('p', {
    staticClass: "davi-curs"
  }, [_vm._v("Ingresos")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": ""
    }
  }, [_c('p', {
    staticClass: "font-red signo animated bounceIn dura_3"
  }, [_vm._v("\n            >")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner animated fadeInRight dura_2",
    attrs: {
      "sm4": ""
    }
  }, [_c('p', {
    staticClass: "davi-curs"
  }, [_vm._v("Gastos")])])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "animated fadeInLeft dura_4",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": "",
      "hidden-xs-only": ""
    }
  }, [_c('image-app', {
    attrs: {
      "imaSize": 80,
      "imaSrc": "design/banco3-1-1",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "Lo está haciendo muy bien, está optimizando su dinero, y puede ahorrar y construir patrimonio.",
      "titleLevel": "p"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v(" Lo está haciendo muy bien, ")]), _vm._v(" "), _c('template', {
    slot: "partTwo"
  }, [_vm._v("está optimizando su dinero y puede")]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" ahorrar y construir patrimonio.")])], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5abc591b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-44.vue
// module id = 1016
// module chunks = 1